import { createFileRoute } from '@tanstack/react-router'
import { ProductGate } from '@bloo-team/core-shell'
import { IntegrationsInstancesPage } from '@bloo-team/product-synthai'

/** Composer shim (S5.0): Settings · Integrations · Instances — @bloo-team/product-synthai, behind the SynthAI gate (its backend serves it). */
function InstancesRoute() {
  const { clusterId, scopeId } = Route.useParams()
  return (
    <ProductGate product="synthai" clusterId={clusterId} scopeId={scopeId}>
      <IntegrationsInstancesPage clusterId={clusterId} scopeId={scopeId} />
    </ProductGate>
  )
}

export const Route = createFileRoute('/$clusterId/$scopeId/settings/integrations/instances')({
  component: InstancesRoute,
})
